// Format Morning Line (ML) odds for display.
// Feed stores ml_odds as a string: already-fractional ("5/2", "8/5") or a bare
// whole number ("6" => 6-to-1). Display convention (owner: all-slash):
//   "5/2" -> "5/2" (unchanged), "6" -> "6/1", empty/null -> "-".
export const formatML = (ml) => {
  if (ml === null || ml === undefined) return "-";
  const s = String(ml).trim();
  if (!s) return "-";
  if (s.includes("/")) return s;            // already fractional
  if (/^\d+$/.test(s)) return `${s}/1`;     // whole number -> N/1
  return s;                                 // any other format left as-is
};
